import React from 'react'

import { Avatar } from '@fourthwall/components'

import * as S from './UserDetails.styled'

type UserDetailsProps = {
  name: string
  email: string
}

export const UserDetails = ({ name, email }: UserDetailsProps) => (
  <S.Content>
    <S.AvatarContainer>
      <Avatar name={name} />
    </S.AvatarContainer>
    <S.UserName>{name}</S.UserName>
    {email && <S.UserEmail>{email}</S.UserEmail>}
  </S.Content>
)
